import { POST } from '@/server/http';
import URLS from '@/server/urls';

export default async ({
    id = 0,
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.dictionary.remove, { id }, options);
    if (error) return { error, status };
    return content || {};
};
